import { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';

/* Each route is its own chunk so the first paint ships only the shell and
   the homepage. The Layout wraps the routed page in a Suspense boundary with
   a film-frame fallback, so a lazy page loads behind a black frame instead of
   a jarring flash of unstyled content. */
const Home = lazy(() => import('./pages/Home'));
const Product = lazy(() => import('./pages/Product'));
const Cortex = lazy(() => import('./pages/Cortex'));
const Models = lazy(() => import('./pages/Models'));
const Docs = lazy(() => import('./pages/Docs'));
const DocPage = lazy(() => import('./pages/DocPage'));
const Privacy = lazy(() => import('./pages/Privacy'));
const Install = lazy(() => import('./pages/Install'));
const NotFound = lazy(() => import('./pages/NotFound'));

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/product" element={<Product />} />
        <Route path="/cortex" element={<Cortex />} />
        <Route path="/models" element={<Models />} />
        <Route path="/docs" element={<Docs />} />
        <Route path="/docs/:slug" element={<DocPage />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/install" element={<Install />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
